/**
 *
 * User can be given a permission to write (create or update) a reply for someone other than himself in 'table' page.
 * open the check status dropdown on any queston cell of a reply row of anyone and start checking or unchecking
 * checking and unckecking will not be applied immediately but stored via this class temporarily.
 * Upon confirmation, stored actions should be applied and emptied out.
 *
 */

import { get, unset, set, isEmpty, cloneDeep } from 'lodash';
import { Option } from '../option';
import { ReplyItem, Check } from '../reply';
import { Subject, Observable } from 'rxjs';
import { compareReplySnapshots } from '../../functions';

export class ForgedReply {
  forged: ReplyItem;
  origin: ReplyItem;
  constructor(reply: ReplyItem) {
    this.forged = cloneDeep({ ...{ snapshot: {} }, ...reply });
    this.origin = reply;
  }
  /**
   *
   * @param option to set on later
   * @param value value to set with
   * @param check_id check id. this should be firebase-generated id or timestamp so that it could be used to determine the order of checks
   */
  set(option: Option, value: any, check_id: string): void {
    if (value === null) {
      unset(this.forged.snapshot, [option.question.id, option.id]);
      if (isEmpty(this.forged.snapshot[option.question.id]))
        unset(this.forged.snapshot, [option.question.id]);
    } else {
      const as = this.forged.as,
        type = typeof option.quota === 'number' ? 'confirmed' : 'static';
      set(this.forged.snapshot, [option.question.id, option.id], {
        as,
        type,
        value,
        id: check_id
      });
    }
  }
  get(option: Option): Check {
    return get(this.forged.snapshot, [option.question.id, option.id]) || null;
  }
  setAs (as:string) {
    set(this.forged, 'as', as);
  }
  getAs () {
    return get(this.forged, 'as');
  }
  empty() {
    this.forged.snapshot = {};
  }
}
export class ForgeryStore {
  stores = new Map<string, ForgedReply>();

  private changeEvent = new Subject<string>();
  get onChange(): Observable<string> {
    return this.changeEvent.asObservable();
  }
  get size(): number {
    return this.stores.size;
  }
  private hasChanged (item:ForgedReply) {
    return !(compareReplySnapshots(item.origin.snapshot, item.forged.snapshot) && item.origin.as === item.forged.as);
  }
  setCheck(
    reply: ReplyItem,
    option: Option,
    value: any,
    check_id: string
  ): void {
    let single = this.stores.get(reply.id);
    if (!single) {
      single = new ForgedReply(reply);
      this.stores.set(reply.id, single);
    }
    single.set(option, value, check_id);
    if (!this.hasChanged(single)) {
      this.stores.delete(reply.id);
    }
    this.changeEvent.next(reply.id);
  }
  getCheck(option: Option, as: string): Check {
    let single = Array.from(this.stores.values()).find(
      store => store.forged.as === as
    );
    if (single) return single.get(option);
    else return undefined;
  }
  setAs(
    reply: ReplyItem,
    as:string,
  ): void {
    let single = this.stores.get(reply.id);
    if (!single) {
      single = new ForgedReply(reply);
      this.stores.set(reply.id, single);
    }
    single.setAs(as);
    if (!this.hasChanged(single)) {
      this.stores.delete(reply.id);
    }
    this.changeEvent.next(reply.id);
  }
  getForgedReply(id: string): ForgedReply {
    return this.stores.get(id);
  }
  empty(): void {
    const reply_ids = Array.from(this.stores.keys());
    this.stores.forEach(single => single.empty());
    this.stores.clear();
    reply_ids.forEach(reply_id=>this.changeEvent.next(reply_id));
    
  }
}
